import { render, staticRenderFns } from "./MobileGame.vue?vue&type=template&id=230e1e0e"
import script from "./MobileGame.vue?vue&type=script&lang=js"
export * from "./MobileGame.vue?vue&type=script&lang=js"
import style0 from "./MobileGame.vue?vue&type=style&index=0&id=230e1e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports